import React, { ReactNode } from 'react';
import {
  Typography,
  Box,
  Card,
  CardContent,
  Chip
} from '@mui/material';

interface ForecastConfidenceCardProps {
  confidence: string;
  titleComponent?: ReactNode;
}

const ForecastConfidenceCard: React.FC<ForecastConfidenceCardProps> = ({ 
  confidence,
  titleComponent
}) => {
  // Determine color based on confidence level
  const getConfidenceColor = (confidenceLevel: string) => {
    switch(confidenceLevel.toLowerCase()) {
      case 'high':
        return '#06D6A0'; // Updated to match standard green
      case 'medium':
        return '#FFD166'; // Updated to match standard yellow
      case 'low':
      default:
        return '#FF6B6B'; // Updated to match standard red
    }
  };

  const color = getConfidenceColor(confidence);

  return (
    <Card elevation={3} sx={{ height: '100%' }}>
      <CardContent>
        {titleComponent || (
          <Typography variant="h5" gutterBottom>
            Forecast Confidence
          </Typography>
        )}
        <Box sx={{ 
          height: 300, 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          alignItems: 'center',
          textAlign: 'center'
        }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              Confidence Level
            </Typography>
            <Chip 
              label={confidence}
              sx={{ 
                fontSize: '1.5rem', 
                height: 'auto', 
                padding: '1rem 1.5rem',
                bgcolor: `${color}15`,
                color: color,
                fontWeight: 'bold',
                border: `2px solid ${color}`
              }}
            />
          </Box>
          
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '80%', mt: 2 }}>
            {confidence === 'High' && 'Strong consensus in the prediction model with clear evidence.'}
            {confidence === 'Medium' && 'Moderate agreement in the prediction model with supporting evidence.'}
            {confidence === 'Low' && 'Limited consensus in the prediction model or insufficient data.'}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ForecastConfidenceCard; 